export type GatewayLinkReadMode = 'webdev' | 'shadow' | 'gateway_link'
export type GatewayLinkWriteMode = Exclude<GatewayLinkReadMode, 'shadow'>

export interface GatewayLinkRouteInput {
  gatewayId: string
  gatewayUrl: string
  acquisitionMode: GatewayLinkReadMode
  tagReadMode: GatewayLinkReadMode
  historyMode: GatewayLinkReadMode
  alarmMode: GatewayLinkReadMode
  opcMode: GatewayLinkReadMode
  databaseMode: GatewayLinkReadMode
  healthMode: GatewayLinkReadMode
  writeMode: GatewayLinkWriteMode
}

export interface GatewayLinkRoute extends GatewayLinkRouteInput {
  createdAt: string
  updatedAt: string
  online: boolean
  sessionId: string | null
  fenceEpoch: number | null
  sessionExpiresAt: string | null
  negotiatedCapabilities: string[]
}

export type GatewayLinkPreset = 'webdev' | 'shadow' | 'gateway_link_reads' | 'gateway_link_all'

export function defaultGatewayLinkRoute(
  gatewayId: string,
  gatewayUrl: string
): GatewayLinkRouteInput {
  return {
    gatewayId,
    gatewayUrl,
    acquisitionMode: 'webdev',
    tagReadMode: 'webdev',
    historyMode: 'webdev',
    alarmMode: 'webdev',
    opcMode: 'webdev',
    databaseMode: 'webdev',
    healthMode: 'webdev',
    writeMode: 'webdev'
  }
}

export function gatewayLinkRouteInput(route: GatewayLinkRoute): GatewayLinkRouteInput {
  const {
    gatewayId,
    gatewayUrl,
    acquisitionMode,
    tagReadMode,
    historyMode,
    alarmMode,
    opcMode,
    databaseMode,
    healthMode,
    writeMode
  } = route
  return {
    gatewayId,
    gatewayUrl,
    acquisitionMode,
    tagReadMode,
    historyMode,
    alarmMode,
    opcMode,
    databaseMode,
    healthMode,
    writeMode
  }
}

export function applyGatewayLinkPreset(
  route: GatewayLinkRouteInput,
  preset: GatewayLinkPreset
): GatewayLinkRouteInput {
  const readMode: GatewayLinkReadMode =
    preset === 'webdev' ? 'webdev' : preset === 'shadow' ? 'shadow' : 'gateway_link'
  return {
    ...route,
    acquisitionMode: readMode,
    tagReadMode: readMode,
    historyMode: readMode,
    alarmMode: readMode,
    opcMode: readMode,
    databaseMode: readMode,
    healthMode: readMode,
    writeMode: preset === 'gateway_link_all' ? 'gateway_link' : 'webdev'
  }
}
